import { CalEventStatus } from './cal-event-status.js';
export const CAL_EVENT_TERMINAL_STATUS_IDS = [
    CalEventStatus.COMPLETED,
    CalEventStatus.CANCELLED,
];
//# sourceMappingURL=cal-event-terminal-status-ids.js.map